import {Injectable} from "@angular/core";
import {StringInterpolationService} from "../../../common/string.interpolation/string.interpolation.service";
import {SystemConfigurationValues} from "../../../common/configuration/services/system.configuration.utils";
import * as _ from "lodash";


/**
 *  @ngModule CommonProvidersModule
 *  @description  this service function as util to operations that are related to resource address.
 *  It among other read and stores the address pattern configuration.
 *
 **/
@Injectable({ providedIn: 'root' })
  export class ResourceAddressService {
	private addressPaternConfigVal:string;
	constructor(private stringInterpolationService:StringInterpolationService,private sysCfg:SystemConfigurationValues) {
		this.addressPaternConfigVal = this.sysCfg.getValidatedString("resourceAddressPattern","[STREET_ADDRESS],[CITY],[PROVICE],[COUNTRY],[POSTAL_CODE]");
	}

	/**
	 *  @description  Receive  a object that its properties store the address. it  uses the  address pattern configuration to create the text representation  of the address
	 *  @param address  a object that its properties store the address data
	 *  @returns a string of the formatted text representation  of the address.
	 *  If there is no configuration value or address value an empty  string is returned.
	 **/
	public getFormattedAddress(address:any):string{
		if (_.isEmpty(address) || (_.isEmpty(this.addressPaternConfigVal))){
			return "";
		}
		else{
			return  this.stringInterpolationService.interpolate(address,this.addressPaternConfigVal);
		}
	}

}


